import { html } from 'lit';
import './header-text.component';

export const renderHeaderText = (header: string, subheader?: string) =>
    html`<header-text .header=${header} .subheader=${subheader}></header-text>`;
